import React, { useEffect } from "react";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { MessagingProvider } from "./contexts/MessagingContext";
import { PresenceProvider } from "./contexts/PresenceContext";
import { ProfileSyncProvider } from "./contexts/ProfileSyncContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { ChatWidgetProvider } from "./contexts/ChatWidgetContext";
import Routes from "./Routes";
import TimezoneSync from "./components/utility/TimezoneSync";
import ProfilePictureNotification from "./components/notifications/ProfilePictureNotification";
import ModerationGuard from "./components/auth/ModerationGuard";
import LiveChatWidget from "./components/LiveChatWidget";
// Debug components removed for production
import { ensureRequiredTables } from "./utils/databaseSetup";
import notificationEmailWatcher from "./services/notificationEmailWatcher";

// Import global styles
import "./styles/animations.css";

// Import debug utilities for development
import "./utils/errorHandling";
import "./utils/notificationSoundDebugger";

function App() {
  // Ensure required database tables exist
  useEffect(() => {
    ensureRequiredTables().catch(err => 
      console.error("Failed to ensure required tables:", err)
    );
  }, []);

  // Start notification email watcher
  useEffect(() => {
    notificationEmailWatcher.startWatching();
    notificationEmailWatcher.processBacklog();

    return () => {
      notificationEmailWatcher.stopWatching();
    };
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <ProfileSyncProvider>
            <ChatWidgetProvider>
              <NotificationProvider>
                <ProfilePictureNotification />
                <MessagingProvider>
                  <PresenceProvider>
                    <ModerationGuard>
                      <TimezoneSync />
                      <Routes />
                      <LiveChatWidget />
                    </ModerationGuard>
                  </PresenceProvider>
                </MessagingProvider>
              </NotificationProvider>
            </ChatWidgetProvider>
          </ProfileSyncProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
